/* SoccerDrop — correctifs panier + mobile + palette + flocage + tiroir enrichi + ouverture auto (sans re-animation) + descriptif version + compteur header. */
(function () {
  try { if (/^\/cart\/?$/.test(location.pathname) || location.pathname.indexOf('/cart?') === 0) { location.replace('/'); return; } } catch (e) {}

  try {
    var ov = document.createElement('style');
    ov.setAttribute('data-sc-fix', 'overflow');
    ov.textContent = '@media (max-width: 989px){ html { overflow-x: clip; } }';
    (document.head || document.documentElement).appendChild(ov);
  } catch (e) {}

  try {
    var pal = document.createElement('style');
    pal.setAttribute('data-sc-fix', 'palette');
    pal.textContent = ':root{--sc-navy:#0B1B2B;--sc-cyan:#00E0FF;}'
      + '.product-form__submit,.cart__checkout-button,button[name="checkout"],.shopify-payment-button__button--unbranded{background:var(--sc-cyan) !important;color:var(--sc-navy) !important;border-color:var(--sc-cyan) !important;transition:background .15s ease,color .15s ease;}'
      + '.product-form__submit:hover,.cart__checkout-button:hover,button[name="checkout"]:hover,.shopify-payment-button__button--unbranded:hover{background:var(--sc-navy) !important;color:#fff !important;border-color:var(--sc-navy) !important;}'
      + '.product-form__submit[disabled],.product-form__submit:disabled{background:#c7d0d8 !important;color:#5b6a77 !important;border-color:#c7d0d8 !important;}'
      + '.sc-extras{padding:0 14px;font-family:var(--font-body-family,inherit);}'
      + '.sc-reco__t{font-size:12px;font-weight:700;letter-spacing:.4px;margin:6px 0 8px;color:#0B1B2B;}'
      + '.sc-reco__row{display:flex;gap:10px;align-items:stretch;}'
      + '.sc-reco__card{flex:1 1 0;min-width:0;display:flex;flex-direction:column;border:1px solid rgba(11,27,43,.12);border-radius:10px;padding:8px;text-align:center;text-decoration:none;}'
      + '.sc-reco__imgwrap{display:block;height:84px;border-radius:7px;background:#eef2f5;overflow:hidden;margin-bottom:6px;}'
      + '.sc-reco__imgwrap img{width:100%;height:100%;object-fit:cover;object-position:top center;display:block;}'
      + '.sc-reco__name{display:block;font-size:11px;line-height:1.2;color:#0B1B2B;height:28px;overflow:hidden;margin-bottom:2px;}'
      + '.sc-reco__price{display:block;font-size:12px;font-weight:700;color:#0B1B2B;margin:2px 0 8px;}'
      + '.sc-reco__add{display:block;margin-top:auto;border:1px solid #00E0FF;background:#fff;color:#0B1B2B;border-radius:7px;padding:6px 0;font-size:11px;}'
      + '.sc-promo{display:flex;gap:8px;margin:12px 0;}'
      + '.sc-promo input{flex:1;min-width:0;border:1px solid rgba(11,27,43,.25);border-radius:8px;padding:9px 12px;font-size:13px;}'
      + '.sc-promo button{background:#0B1B2B;color:#fff;border:0;border-radius:8px;padding:0 18px;font-size:13px;cursor:pointer;}'
      + '.sc-trust{display:flex;justify-content:space-around;gap:6px;margin:10px 0 4px;border-top:1px solid rgba(11,27,43,.1);padding-top:12px;}'
      + '.sc-trust>div{font-size:10px;color:#5a6b78;text-align:center;line-height:1.3;}'
      + '.sc-trust .sc-ic{display:block;font-size:15px;margin-bottom:2px;}'
      + '.sc-empty-actions{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;margin-top:10px;}'
      + '.sc-empty-btn{display:inline-block;padding:12px 22px;border-radius:10px;font-size:13px;font-weight:600;text-decoration:none;letter-spacing:.3px;line-height:1;}'
      + '.sc-empty-btn--outline{border:1px solid #0B1B2B;color:#0B1B2B;background:#fff;}'
      + '.sc-empty-btn--outline:hover{background:#0B1B2B;color:#fff;}'
      + '.sc-empty-btn--fill{background:#00E0FF;color:#0B1B2B;border:1px solid #00E0FF;}'
      + '.sc-empty-btn--fill:hover{background:#0B1B2B;color:#fff;border-color:#0B1B2B;}'
      + '.sc-promo-msg{font-size:12px;margin:-4px 0 10px;text-align:center;}'
      + '.sc-promo-msg--ok{color:#1d9e75;}'
      + '.sc-promo-msg--err{color:#c0392b;}'
      + '.fp-desc{display:flex;gap:12px;align-items:flex-start;background:#eef5ff;border:1px solid #dbe7fb;border-radius:12px;padding:14px 16px;margin-top:12px;font-family:var(--font-body-family,inherit);}'
      + '.fp-desc__ic{width:30px;height:30px;flex:0 0 30px;border-radius:50%;background:#2f7fe0;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-style:italic;font-size:15px;}'
      + '.fp-desc__txt{font-size:14px;line-height:1.5;color:#334155;}'
      + '.fp-desc__txt b{color:#0B1B2B;font-weight:800;}';
    (document.head || document.documentElement).appendChild(pal);
  } catch (e) {}

  try {
    var ci = document.createElement('style');
    ci.setAttribute('data-sc-fix', 'cartitem');
    ci.textContent = '#CartDrawer thead{display:none !important;}'
      + '#CartDrawer .cart-items,#CartDrawer .cart-items>tbody{display:block !important;width:100% !important;}'
      + '#CartDrawer .cart-item{display:grid !important;grid-template-columns:64px 1fr !important;grid-template-areas:"m d" "m t" "m q" !important;column-gap:12px !important;row-gap:2px !important;padding:12px 0 !important;border-bottom:1px solid rgba(11,27,43,.08) !important;align-items:start !important;width:100% !important;box-sizing:border-box !important;}'
      + '#CartDrawer .cart-item__media{grid-area:m !important;width:64px !important;max-width:64px !important;}'
      + '#CartDrawer .cart-item__image{width:64px !important;height:auto !important;max-width:64px !important;display:block !important;border-radius:8px !important;}'
      + '#CartDrawer .cart-item__details{grid-area:d !important;min-width:0 !important;}'
      + '#CartDrawer .cart-item__totals{grid-area:t !important;text-align:left !important;}'
      + '#CartDrawer .cart-item__quantity{grid-area:q !important;padding:0 !important;}'
      + '#CartDrawer .cart-item .quantity,#CartDrawer .cart-item quantity-input{border-radius:8px !important;width:116px !important;overflow:hidden !important;}'
      + '#CartDrawer .cart-item .quantity__button{width:36px !important;}'
      + '#CartDrawer .cart-item .quantity__input{width:auto !important;min-width:0 !important;}'
      + '#CartDrawer .drawer__inner{display:flex !important;flex-direction:column !important;overflow-y:auto !important;}'
      + '#CartDrawer cart-drawer-items,#CartDrawer .drawer__contents{display:block !important;flex:0 0 auto !important;overflow:visible !important;min-height:0 !important;}'
      + '#CartDrawer .drawer__footer{flex:0 0 auto !important;}';
    (document.head || document.documentElement).appendChild(ci);
  } catch (e) {}

  function formId(f) { var a = f.getAttribute && f.getAttribute('id'); return a || ''; }
  function idInput(f) { return f.querySelector('input[name="id"]'); }
  function isMainForm(f) { return formId(f).indexOf('product-form-') === 0; }
  function managesOwnVariant(f) {
    return !!f.querySelector('variant-selects, [data-selected-variant], select[name^="options"], input[name^="options"]');
  }
  function isProtected(f) { return !isMainForm(f) && !managesOwnVariant(f); }
  var snap = new WeakMap();
  function snapshot(f) {
    try { if (!isProtected(f) || snap.has(f)) return; var i = idInput(f); if (i && i.value) snap.set(f, i.value); } catch (e) {}
  }
  function scan(root) {
    try { (root || document).querySelectorAll('form[action*="/cart/add"]').forEach(snapshot); } catch (e) {}
  }

  function flocValue(kind) {
    var el = document.querySelector('[id^="ScCustom' + kind + '"]');
    return el && el.value ? el.value.trim() : '';
  }
  function injectFlocage(f) {
    try {
      var map = { 'Nom': flocValue('Name'), 'Numéro': flocValue('Number') };
      Object.keys(map).forEach(function (key) {
        var inp = f.querySelector('input[data-sc-prop="' + key + '"]');
        var val = map[key];
        if (val) {
          if (!inp) {
            inp = document.createElement('input');
            inp.type = 'hidden';
            inp.setAttribute('data-sc-prop', key);
            inp.name = 'properties[' + key + ']';
            f.appendChild(inp);
          }
          inp.disabled = false;
          inp.value = val;
        } else if (inp) {
          inp.disabled = true;
          inp.value = '';
        }
      });
    } catch (e) {}
  }

  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function extrasHTML() {
    return '<div class="sc-extras">'
      + '<div class="sc-reco" id="ScReco" hidden><div class="sc-reco__t">TU AIMERAS AUSSI</div><div class="sc-reco__row" id="ScRecoRow"></div></div>'
      + '<form class="sc-promo" id="ScPromo"><input type="text" name="code" placeholder="Code promo" autocomplete="off"><button type="submit">OK</button></form>'
      + '<div class="sc-trust"><div><span class="sc-ic">🔒</span>Paiement sécurisé</div><div><span class="sc-ic">↩</span>Retours 14j</div><div><span class="sc-ic">✈</span>Suivi colis</div></div>'
      + '</div>';
  }
  var _scRecoHTML = null;
  function populateReco() {
    try {
      var row = document.getElementById('ScRecoRow');
      if (!row || row.dataset.done) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items || !c.items.length) return;
        var pid = c.items[0].product_id;
        var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = 1; });
        fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related').then(function (r) { return r.json(); }).then(function (rec) {
          var prods = (rec.products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 2);
          if (!prods.length) return;
          row.innerHTML = prods.map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var imgTag = img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '';
            return '<a class="sc-reco__card" href="/products/' + p.handle + '">'
              + '<span class="sc-reco__imgwrap">' + imgTag + '</span>'
              + '<span class="sc-reco__name">' + p.title + '</span>'
              + '<span class="sc-reco__price">' + money(p.price) + '</span>'
              + '<span class="sc-reco__add">Choisir</span></a>';
          }).join('');
          row.dataset.done = '1';
          _scRecoHTML = row.innerHTML;
          var wrap = document.getElementById('ScReco'); if (wrap) wrap.hidden = false;
        }).catch(function () {});
      }).catch(function () {});
    } catch (e) {}
  }
  function ensureExtras() {
    try {
      var footer = document.querySelector('#CartDrawer .drawer__footer');
      if (!footer || footer.querySelector('.sc-extras')) return;
      var anchor = footer.querySelector('.cart-drawer__footer');
      var wrap = document.createElement('div');
      wrap.innerHTML = extrasHTML();
      var node = wrap.firstChild;
      if (anchor) footer.insertBefore(node, anchor); else footer.insertBefore(node, footer.firstChild);
      if (_scRecoHTML) {
        var row = document.getElementById('ScRecoRow');
        if (row) { row.innerHTML = _scRecoHTML; row.dataset.done = '1'; var w = document.getElementById('ScReco'); if (w) w.hidden = false; }
      } else {
        populateReco();
      }
    } catch (e) {}
  }

  function customizeEmptyCart() {
    try {
      var box = document.querySelector('#CartDrawer .cart-drawer__empty-content');
      if (!box || box.dataset.scEmpty) return;
      var title = box.querySelector('.cart__empty-text');
      if (title) title.textContent = 'Ton panier est vide.';
      var oldBtn = box.querySelector('a.button');
      var wrap = document.createElement('div');
      wrap.className = 'sc-empty-actions';
      wrap.innerHTML = '<a class="sc-empty-btn sc-empty-btn--outline" href="/collections/maillots-saison-2026-2027">NOUVEAUTÉS</a>'
        + '<a class="sc-empty-btn sc-empty-btn--fill" href="/collections/meilleurs-ventes">MEILLEURES VENTES</a>';
      if (oldBtn && oldBtn.parentNode) { oldBtn.parentNode.insertBefore(wrap, oldBtn); oldBtn.style.display = 'none'; }
      else { box.appendChild(wrap); }
      box.dataset.scEmpty = '1';
    } catch (e) {}
  }

  function hideBaseCartLinks() {
    try {
      document.querySelectorAll('#CartDrawer a[href="/cart"], #CartDrawer a[href^="/cart?"], #CartDrawer a[href$="/cart"]').forEach(function (a) {
        a.style.display = 'none';
      });
    } catch (e) {}
  }

  function enhanceCollectionCards() {
    try {
      document.querySelectorAll('.card-wrapper').forEach(function (w) {
        if (w.dataset.scCta) return;
        w.dataset.scCta = '1';
        var link = w.querySelector('a[href*="/products/"]');
        var info = w.querySelector('.card-information');
        if (link && info) {
          var a = document.createElement('a');
          a.className = 'sc-cta-voir';
          a.href = link.getAttribute('href');
          a.textContent = 'VOIR LE MAILLOT';
          info.appendChild(a);
        }
      });
    } catch (e) {}
  }

  /* ---- Fiche produit : descriptif sous les cartes FAN / JOUEUR ---- */
  var SC_FAN_TXT = '<b>Version supporter :</b> coupe régulière et tissu léger respirant, parfaite au quotidien pour afficher les couleurs de ton équipe.';
  var SC_PLAYER_TXT = '<b>Version joueur :</b> coupe ajustée type match et technologie anti-transpiration, la réplique exacte de celle portée sur le terrain.';
  function scVerIsPlayer(el) {
    if (!el) return false;
    var id = el.id || '';
    if (/FpCardPlayer/i.test(id)) return true;
    if (/FpCardFan/i.test(id)) return false;
    var t = el.textContent || '';
    if (/joueur|player/i.test(t)) return true;
    return false;
  }
  function scEnsureVerDesc(block) {
    var cards = block.querySelector('.fp-block__cards');
    if (!cards) return null;
    var desc = block.querySelector('.fp-desc');
    if (!desc) {
      desc = document.createElement('div');
      desc.className = 'fp-desc';
      desc.innerHTML = '<span class="fp-desc__ic">i</span><span class="fp-desc__txt"></span>';
      cards.parentNode.insertBefore(desc, cards.nextSibling);
    }
    return desc;
  }
  function scSetVer(block, card) {
    var desc = scEnsureVerDesc(block);
    if (!desc) return;
    var txt = desc.querySelector('.fp-desc__txt');
    if (txt) txt.innerHTML = scVerIsPlayer(card) ? SC_PLAYER_TXT : SC_FAN_TXT;
  }
  function scActiveCard(block) {
    var cards = block.querySelectorAll('.fp-card');
    var active = block.querySelector('.fp-card--active, .fp-card.is-active, .fp-card.active, .fp-card.selected, .fp-card[aria-checked="true"], .fp-card[aria-pressed="true"]');
    if (!active) {
      for (var i = 0; i < cards.length; i++) { if (!scVerIsPlayer(cards[i])) { active = cards[i]; break; } }
      if (!active) active = cards[0];
    }
    return active;
  }
  function enhanceVersionBlock() {
    try {
      document.querySelectorAll('[id^="FpBlock-"]').forEach(function (block) {
        var existed = !!block.querySelector('.fp-desc');
        var desc = scEnsureVerDesc(block);
        if (!desc || existed) return;
        var active = scActiveCard(block);
        if (active) scSetVer(block, active);
      });
    } catch (e) {}
  }
  try {
    if (!window.__scVerDeleg) {
      window.__scVerDeleg = 1;
      document.addEventListener('click', function (e) {
        try {
          var card = e.target.closest ? e.target.closest('.fp-card') : null;
          if (!card) return;
          var block = card.closest('[id^="FpBlock-"]');
          if (!block) return;
          scSetVer(block, card);
          setTimeout(function () { scSetVer(block, card); }, 60);
        } catch (err) {}
      }, true);
    }
  } catch (e) {}

  function showPromoMsg(form, msg, ok) {
    try {
      var m = form.parentNode.querySelector('.sc-promo-msg');
      if (!m) { m = document.createElement('div'); m.className = 'sc-promo-msg'; form.parentNode.insertBefore(m, form.nextSibling); }
      m.className = 'sc-promo-msg ' + (ok ? 'sc-promo-msg--ok' : 'sc-promo-msg--err');
      m.textContent = msg;
    } catch (e) {}
  }
  function applyPromo(form) {
    try {
      var input = form.querySelector('input[name="code"]');
      var code = (input && input.value ? input.value : '').trim();
      if (!code) return;
      var btn = form.querySelector('button');
      var label = btn ? btn.textContent : 'OK';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      var ff = _scRealFetch || window.fetch;
      ff('/discount/' + encodeURIComponent(code), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function () { return ff('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var applied = (c.cart_level_discount_applications || []).some(function (d) { return (d.title || '').toLowerCase() === code.toLowerCase(); });
          if (btn) { btn.disabled = false; btn.textContent = label; }
          if (applied) { refreshDrawer(false); }
          else { showPromoMsg(form, 'Code invalide ou non applicable', false); }
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } showPromoMsg(form, 'Erreur, réessaie', false); });
    } catch (e) {}
  }

  function updateBars(count) {
    try {
      function upd(card, goal, doneMsg) {
        if (!card) return;
        var rem = Math.max(0, goal - count);
        var pct = Math.min(100, Math.round(count / goal * 100));
        var frac = card.querySelector('.scg-frac'); if (frac) frac.textContent = Math.min(count, goal) + '/' + goal;
        var fill = card.querySelector('.scg-fill'); if (fill) fill.style.width = pct + '%';
        var sub = card.querySelector('.scg-sub');
        if (sub) {
          if (rem === 0) { sub.textContent = doneMsg; }
          else { sub.innerHTML = 'Encore <strong>' + rem + ' maillot' + (rem > 1 ? 's' : '') + '</strong>'; }
        }
      }
      upd(document.querySelector('#CartDrawer .scg-card--ship'), 2, 'Débloquée !');
      upd(document.querySelector('#CartDrawer .scg-card--gift'), 4, 'Débloqué !');
    } catch (e) {}
  }
  function updateCartBubble(count) {
    try {
      document.querySelectorAll('#cart-icon-bubble').forEach(function (wrap) {
        var bub = wrap.querySelector('.cart-count-bubble');
        if (count > 0) {
          if (!bub) {
            bub = document.createElement('div');
            bub.className = 'cart-count-bubble';
            bub.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            wrap.appendChild(bub);
          }
          var vis = bub.querySelector('span[aria-hidden="true"]') || bub.querySelector('span');
          if (vis) vis.textContent = count;
          var hid = bub.querySelector('.visually-hidden');
          if (hid) hid.textContent = count + ' article' + (count > 1 ? 's' : '');
        } else if (bub) {
          bub.remove();
        }
      });
    } catch (e) {}
  }
  function refreshBars() {
    try {
      var f = _scRealFetch || window.fetch;
      f('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var n = c.item_count || 0;
        updateBars(n); updateCartBubble(n);
        var cd = document.querySelector('cart-drawer'); if (cd) { if (n === 0) cd.classList.add('is-empty'); else cd.classList.remove('is-empty'); }
      }).catch(function () {});
    } catch (e) {}
  }

  function neutralizeNativeCart() {
    try {
      var cd = document.querySelector('cart-drawer');
      if (cd && !cd._scNoop) { cd.renderContents = function () {}; cd._scNoop = true; }
      var items = document.querySelector('cart-drawer-items');
      if (items && !items._scNoop && typeof items.renderContents === 'function') { items.renderContents = function () {}; items._scNoop = true; }
      var cn = document.querySelector('cart-notification');
      if (cn && !cn._scNoop) { cn.renderContents = function () {}; cn._scNoop = true; }
    } catch (e) {}
  }

  var _scBusy = false;
  var _scRealFetch = null;
  function refreshDrawer(forceOpen) {
    if (_scBusy) return;
    _scBusy = true;
    var dPre = document.querySelector('cart-drawer');
    var wasOpen = !!(dPre && dPre.classList.contains('active'));
    var f = _scRealFetch || window.fetch;
    f('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawerHtml = data && data['cart-drawer'];
        if (drawerHtml) {
          var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
          var srcInner = doc.querySelector('#CartDrawer');
          var tgtInner = document.querySelector('#CartDrawer');
          if (srcInner && tgtInner) {
            var scroller = (tgtInner.matches && tgtInner.matches('.drawer__inner')) ? tgtInner : (tgtInner.querySelector('.drawer__inner') || tgtInner);
            var st = scroller ? scroller.scrollTop : 0;
            tgtInner.innerHTML = srcInner.innerHTML;
            var scroller2 = (tgtInner.matches && tgtInner.matches('.drawer__inner')) ? tgtInner : (tgtInner.querySelector('.drawer__inner') || tgtInner);
            if (scroller2) scroller2.scrollTop = st;
          }
        }
        var bubbleHtml = data && data['cart-icon-bubble'];
        if (bubbleHtml) {
          var b = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('#cart-icon-bubble');
          var bt = document.querySelector('#cart-icon-bubble');
          if (b && bt) bt.innerHTML = b.innerHTML;
        }
        ensureExtras();
        customizeEmptyCart();
        hideBaseCartLinks();
        var d = document.querySelector('cart-drawer');
        if (d && forceOpen && !wasOpen) { try { if (typeof d.open === 'function') d.open(); } catch (e) {} }
        refreshBars();
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { _scBusy = false; }, 400); });
  }

  function init() {
    scan(document);
    neutralizeNativeCart();
    ensureExtras();
    customizeEmptyCart();
    hideBaseCartLinks();
    enhanceCollectionCards();
    enhanceVersionBlock();
    refreshBars();
    try {
      var _f = window.fetch;
      if (_f && !window.__scFetchPatched) {
        window.__scFetchPatched = true;
        _scRealFetch = _f;
        window.fetch = function () {
          var args = arguments, p = _f.apply(this, args);
          try {
            var u = (args[0] && args[0].url) || args[0] || '';
            if (typeof u === 'string' && !_scBusy) {
              if (/\/cart\/add(\.js|\?|$)/.test(u)) {
                p.then(function () { setTimeout(function () { refreshDrawer(true); }, 150); }).catch(function () {});
              } else if (/\/cart\/(change|update)(\.js|\?|$)/.test(u)) {
                p.then(function () { setTimeout(function () { refreshDrawer(false); }, 150); }).catch(function () {});
              }
            }
          } catch (e) {}
          return p;
        };
      }
    } catch (e) {}
    try {
      new MutationObserver(function (muts) {
        var touched = false;
        for (var k = 0; k < muts.length; k++) {
          var added = muts[k].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.matches && n.matches('form[action*="/cart/add"]')) snapshot(n);
            if (n.querySelectorAll) scan(n);
            touched = true;
          }
        }
        if (touched) { neutralizeNativeCart(); ensureExtras(); customizeEmptyCart(); hideBaseCartLinks(); enhanceCollectionCards(); enhanceVersionBlock(); }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (f && f.id === 'ScPromo') {
          e.preventDefault();
          applyPromo(f);
          return;
        }
        if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
        if (isMainForm(f)) { injectFlocage(f); }
        if (snap.has(f)) { var i = idInput(f); if (i) i.value = snap.get(f); }
      } catch (err) {}
    }, true);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();